(() => {
  let config;
  const data = document.getElementById('uk-shop-data');
  if (!data) return;
  try { config = JSON.parse(data.textContent); } catch { return; }
  config.root = config.root.endsWith('/') ? config.root : config.root + '/';
  const imageUrl = (source, width) => {
    const url = new URL(source, window.location.origin);
    url.searchParams.set('width', String(width));
    return url.href;
  };
  const format = (value) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: config.currency || 'GBP' }).format(value / 100);
  const storageKey = 'tel-uk-preview-bag-styles-208373940556';
  let bag = [];
  let busy = false;
  let opener;
  let offerNext = 'bag';
  let declinedOfferCart = '';
  let redirectingCart = false;
  const offerDialog = document.getElementById('uk-upsell');
  const bagDialog = document.getElementById('uk-bag');
  if (config.preview) {
    try { bag = JSON.parse(sessionStorage.getItem(storageKey) || '[]').filter((item) => config.products[item.id] && Number.isInteger(item.quantity) && item.quantity > 0).map((item) => ({ id: item.id, quantity: Math.min(item.quantity, 99) })); } catch { bag = []; }
  }
  const save = () => { if (config.preview) { try { sessionStorage.setItem(storageKey, JSON.stringify(bag)); } catch {} } };
  const total = () => bag.reduce((sum, line) => sum + (config.preview ? config.products[line.id].price * line.quantity : line.total), 0);
  const close = (dialog) => { dialog.close(); if (opener?.isConnected) opener.focus(); };
  const show = (dialog, source) => {
    opener = source || document.activeElement;
    [offerDialog, bagDialog].forEach((item) => { if (item.open) item.close(); });
    dialog.showModal();
  };
  const report = (element, error) => { element.hidden = false; element.textContent = error?.message || config.labels.error; };
  const request = async (path, body) => {
    const response = await fetch(config.root + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const json = await response.json();
    if (!response.ok) throw new Error(json.description || config.labels.error);
    return json;
  };
  const refresh = async () => {
    if (config.preview) return;
    const cart = await request('cart.js');
    if (cart.currency) config.currency = cart.currency;
    bag = cart.items.map((item) => ({ id: String(item.variant_id), productId: String(item.product_id), lineKey: item.key, title: item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : ''), image: item.image, quantity: item.quantity, total: item.final_line_price }));
  };
  const count = () => document.querySelectorAll('[data-uk-bag-count]').forEach((element) => { element.textContent = String(bag.reduce((sum, line) => sum + line.quantity, 0)); });
  const addItems = async (items, onAdded) => {
    if (config.preview) {
      items.forEach(({ id, quantity }) => { const existing = bag.find((line) => line.id === id); if (existing) existing.quantity = Math.min(99, existing.quantity + quantity); else bag.push({ id, quantity }); });
      save();
    } else {
      if (items.some((item) => !config.products[item.id]?.available || !config.products[item.id]?.variant)) throw new Error(config.labels.unavailable);
      await request('cart/add.js', { items: items.map((item) => ({ id: config.products[item.id].variant, quantity: item.quantity })) });
      onAdded?.();
      await refresh();
    }
    count();
  };
  const renderBag = () => {
    const lines = bagDialog.querySelector('[data-uk-lines]');
    lines.replaceChildren();
    bagDialog.querySelector('[data-uk-empty]').hidden = bag.length > 0;
    bag.forEach((line) => {
      const product = config.preview ? config.products[line.id] : line;
      const row = document.createElement('div'); row.className = 'uk-bag-line';
      const image = document.createElement('img'); image.src = imageUrl(product.image, 170); image.alt = ''; image.width = 85; image.height = 85;
      const info = document.createElement('div');
      const title = document.createElement('strong'); title.textContent = product.title;
      const quantity = document.createElement('small'); quantity.textContent = config.labels.quantity + ': ' + line.quantity;
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'uk-bag-remove'; remove.textContent = config.labels.remove; remove.setAttribute('aria-label', config.labels.remove + ' ' + product.title);
      remove.addEventListener('click', async () => {
        if (busy) return; busy = true; remove.disabled = true;
        try {
          if (config.preview) { bag = bag.filter((item) => item !== line); save(); } else { await request('cart/change.js', { id: line.lineKey, quantity: 0 }); await refresh(); }
          count(); renderBag(); bagDialog.querySelector('[data-uk-close]').focus();
        } catch (error) { report(bagDialog.querySelector('[data-uk-bag-error]'), error); } finally { busy = false; remove.disabled = false; }
      });
      info.append(title, quantity, remove);
      const price = document.createElement('b'); price.textContent = format(config.preview ? product.price * line.quantity : line.total);
      row.append(image, info, price); lines.append(row);
    });
    bagDialog.querySelector('[data-uk-bag-total]').textContent = format(total());
    bagDialog.querySelector('[data-uk-checkout]').disabled = config.preview || bag.length === 0;
    const extra = bagDialog.querySelector('[data-uk-open-offer]');
    if (extra) extra.hidden = !hasLashes() || inBag('curler') || !config.products.curler?.available;
  };
  const displayBag = async (source) => {
    if (redirectingCart) return;
    try { await refresh(); count(); renderBag(); show(bagDialog, source); } catch (error) { renderBag(); show(bagDialog, source); report(bagDialog.querySelector('[data-uk-bag-error]'), error); }
  };
  const inBag = (key) => bag.some((line) => config.preview ? line.id === key : line.id === String(config.products[key]?.variant));
  const cartSignature = () => config.currency + ':' + bag.map((line) => line.id + ':' + line.quantity).sort().join('|');
  const hasLashes = () => config.preview ? bag.some((line) => line.id.startsWith('lashes')) : bag.some((line) => (config.lashProductIds || []).map(String).includes(line.productId) || Object.entries(config.products).some(([key, product]) => key.startsWith('lashes') && String(product.variant) === line.id));
  const selectedExtras = () => [...offerDialog.querySelectorAll('[data-uk-extra]:checked')].filter((input) => !input.disabled && !input.closest('[data-uk-offer-row]').hidden && !inBag(input.value)).map((input) => ({ id: input.value, quantity: 1 }));
  const checkout = () => { if (!config.preview && bag.length) window.location.assign(config.root + 'checkout'); };
  const finishOffer = () => {
    const next = offerNext;
    if (!inBag('curler')) declinedOfferCart = cartSignature();
    offerNext = 'bag';
    offerDialog.close();
    if (next === 'checkout') checkout();
    else { renderBag(); show(bagDialog, opener); }
  };
  const updateOffer = () => {
    const selected = selectedExtras();
    offerDialog.querySelector('[data-uk-offer-total]').textContent = format(total() + selected.reduce((sum, item) => sum + config.products[item.id].price, 0));
    offerDialog.querySelector('[data-uk-accept]').textContent = offerNext === 'checkout' ? config.labels.checkout : selected.length ? config.labels.accept : config.labels.view;
  };
  const displayOffer = (source, next = 'bag', force = false) => {
    offerNext = next;
    opener = source || document.activeElement;
    let visible = 0;
    offerDialog.querySelectorAll('[data-uk-extra]').forEach((input) => {
      input.checked = false;
      const product = config.products[input.value];
      const row = input.closest('[data-uk-offer-row]');
      row.hidden = (!force && declinedOfferCart === cartSignature()) || !hasLashes() || inBag(input.value) || !product || (!config.preview && (!product.available || !product.variant));
      input.disabled = row.hidden;
      if (!row.hidden) visible++;
    });
    offerDialog.querySelector('[data-uk-modal-error]').hidden = true;
    if (!visible) {
      offerNext = 'bag';
      if (next === 'checkout') checkout();
      else { renderBag(); show(bagDialog, source); }
      return false;
    }
    updateOffer(); show(offerDialog, source);
    return true;
  };
  const prepareCheckout = async (source) => {
    if (busy || config.preview) return;
    busy = true;
    const button = bagDialog.querySelector('[data-uk-checkout]');
    button.disabled = true;
    try {
      await refresh(); count(); renderBag();
      if (bag.length) displayOffer(source, 'checkout');
    } catch (error) {
      if (!config.preview && bag.length) checkout();
      else {
        renderBag(); show(bagDialog, source);
        report(bagDialog.querySelector('[data-uk-bag-error]'), error);
      }
    } finally { busy = false; button.disabled = config.preview || bag.length === 0; }
  };
  window.TELUKCartUI = {
    isBusy: () => busy,
    afterLashesAdded: async (source, direct = false) => {
      try { await refresh(); count(); displayOffer(source, direct ? 'checkout' : 'bag'); }
      catch { window.location.assign(config.root + 'cart'); }
    },
    checkout: prepareCheckout
  };
  offerDialog.querySelectorAll('[data-uk-extra]').forEach((input) => input.addEventListener('change', updateOffer));
  offerDialog.querySelector('[data-uk-accept]').addEventListener('click', async (event) => {
    if (busy) return;
    busy = true;
    const controls = [...offerDialog.querySelectorAll('button, input')].map((element) => ({ element, disabled: element.disabled }));
    const selected = selectedExtras();
    controls.forEach(({ element }) => { element.disabled = true; });
    let complete = false;
    let added = false;
    let redirecting = false;
    try {
      await refresh();
      const items = selected.filter((item) => !inBag(item.id));
      if (items.length) await addItems(items, () => { added = true; });
      count(); renderBag(); complete = true;
    } catch (error) {
      if (added) {
        try { await refresh(); count(); renderBag(); complete = true; }
        catch {
          redirecting = true;
          redirectingCart = true;
          offerDialog.querySelector('[data-uk-offer-total]').textContent = '—';
          offerDialog.querySelector('[data-uk-accept]').textContent = config.labels.checkout;
          offerDialog.setAttribute('aria-busy', 'true');
          window.addEventListener('pageshow', (event) => { if (event.persisted) window.location.reload(); }, { once: true });
          window.location.assign(config.root + 'checkout');
        }
      } else {
        offerDialog.querySelectorAll('[data-uk-extra]').forEach((input) => { input.checked = false; });
        updateOffer();
        report(offerDialog.querySelector('[data-uk-modal-error]'), error);
      }
    }
    finally { if (!redirecting) { busy = false; controls.forEach(({ element, disabled }) => { element.disabled = disabled; }); } }
    if (complete) finishOffer();
  });
  offerDialog.querySelector('[data-uk-skip]').addEventListener('click', () => { if (!busy) finishOffer(); });
  [offerDialog, bagDialog].forEach((dialog) => {
    const dismiss = () => { if (busy) return; if (dialog === offerDialog) finishOffer(); else close(dialog); };
    dialog.querySelectorAll('[data-uk-close]').forEach((button) => button.addEventListener('click', dismiss));
    dialog.addEventListener('cancel', (event) => { if (dialog === offerDialog || busy) { event.preventDefault(); dismiss(); } else if (opener?.isConnected) opener.focus(); });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss(); } });
  });
  bagDialog.querySelector('[data-uk-checkout]').addEventListener('click', (event) => prepareCheckout(event.currentTarget));
  bagDialog.querySelector('[data-uk-open-offer]')?.addEventListener('click', (event) => { if (!busy) displayOffer(event.currentTarget, 'bag', true); });
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-uk-open-bag]').forEach((button) => { if (button.dataset.ukReady) return; button.dataset.ukReady = 'true'; button.addEventListener('click', () => displayBag(button)); });
    scope.querySelectorAll('[data-uk-product]').forEach((section) => {
      if (section.dataset.ukReady) return; section.dataset.ukReady = 'true';
      const quantity = section.querySelector('[data-uk-quantity-input]');
      const totalOutput = section.querySelector('[data-uk-total]');
      const update = () => { const value = Math.min(3, Math.max(1, Math.round(Number(quantity.value) || 1))); quantity.value = String(value); totalOutput.textContent = format(Number(section.dataset.unitPence) * value); section.querySelector('[data-uk-quantity="-1"]').disabled = value <= 1; section.querySelector('[data-uk-quantity="1"]').disabled = value >= 3; };
      section.querySelectorAll('[data-uk-quantity]').forEach((button) => button.addEventListener('click', () => { quantity.value = String(Number(quantity.value) + Number(button.dataset.ukQuantity)); update(); }));
      quantity.addEventListener('change', update); update();
      section.querySelectorAll('[data-uk-photo]').forEach((button) => button.addEventListener('click', () => {
        section.querySelectorAll('[data-uk-shot]').forEach((shot) => { shot.hidden = shot.dataset.ukShot !== button.dataset.ukPhoto; shot.querySelector('img').loading = shot.hidden ? 'lazy' : 'eager'; });
        section.querySelectorAll('[data-uk-photo]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const styleButtons = [...section.querySelectorAll('[data-uk-style]')];
      const chooseStyle = (button, reveal = true) => {
        const model = config.products[button.dataset.ukStyleKey];
        if (!model || section.dataset.ukPurchaseBusy) return;
        section.dataset.selectedStyle = button.dataset.ukStyle;
        section.dataset.unitPence = String(model.price);
        section.querySelectorAll('[data-uk-style-name]').forEach((item) => { item.textContent = model.style; });
        styleButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        const add = section.querySelector('[data-uk-add]');
        add.dataset.ukAdd = button.dataset.ukStyleKey;
        add.disabled = !config.preview && !model.available;
        const main = section.querySelector('[data-uk-shot="1"] img');
        if (main) {
          main.srcset = [400, 650, 900, 1200].map((width) => imageUrl(model.image, width) + ' ' + width + 'w').join(', ');
          main.sizes = '(min-width: 1480px) 680px, (min-width: 761px) 48vw, 90vw';
          main.src = imageUrl(model.image, 1200);
          main.alt = model.title;
        }
        const thumbnail = section.querySelector('[data-uk-photo="1"] img');
        if (thumbnail) { thumbnail.sizes = '80px'; thumbnail.srcset = imageUrl(model.image, 160) + ' 160w'; thumbnail.src = imageUrl(model.image, 160); }
        section.querySelectorAll('[data-uk-photo="2"]').forEach((item) => { item.hidden = model.style !== 'L01'; });
        if (reveal) section.querySelector('[data-uk-photo="1"]')?.click();
        if (!config.preview && model.variant && window.location.pathname.replace(/\/$/, '').endsWith('/products/magnetic-lash-kit-l01')) { const url = new URL(window.location.href); url.searchParams.set('variant', model.variant); history.replaceState({}, '', url); }
        update();
      };
      styleButtons.forEach((button) => button.addEventListener('click', () => chooseStyle(button)));
      if (styleButtons.length) chooseStyle(styleButtons.find((button) => button.getAttribute('aria-pressed') === 'true') || styleButtons[0], !section.querySelector('[data-tel-visual-gallery]'));
      const add = section.querySelector('[data-uk-add]');
      const buy = section.querySelector('[data-uk-buy-now]');
      const purchase = async (event) => {
        const button = event.currentTarget;
        const direct = button === buy;
        if (busy || section.dataset.ukPurchaseBusy || button.disabled || (direct && config.preview)) return;
        update();
        const id = add.dataset.ukAdd;
        const controls = [...section.querySelectorAll('button, select, input')].map((element) => ({ element, disabled: element.disabled }));
        const errorBox = section.querySelector('[data-uk-product-error]');
        errorBox.hidden = true;
        busy = true; section.dataset.ukPurchaseBusy = 'true';
        controls.forEach(({ element }) => { element.disabled = true; });
        let added = false;
        let redirecting = false;
        const showPurchase = async () => {
          if (direct || id.startsWith('lashes')) displayOffer(button, direct ? 'checkout' : 'bag');
          else await displayBag(button);
        };
        try {
          await addItems([{ id, quantity: Number(quantity.value) }], () => { added = true; });
          await showPurchase();
        } catch (error) {
          if (added) {
            try { await refresh(); count(); await showPurchase(); }
            catch {
              redirecting = true; redirectingCart = true;
              window.addEventListener('pageshow', (event) => { if (event.persisted) window.location.reload(); }, { once: true });
              window.location.assign(config.root + (direct ? 'checkout' : 'cart'));
            }
          } else report(errorBox, error);
        }
        finally { if (!redirecting) { busy = false; delete section.dataset.ukPurchaseBusy; controls.forEach(({ element, disabled }) => { element.disabled = disabled; }); } }
      };
      add.addEventListener('click', purchase);
      buy?.addEventListener('click', purchase);
    });
  };
  initialise(); count();
  if (!config.preview) refresh().then(count).catch(() => {});
  window.addEventListener('pageshow', (event) => { if (event.persisted && !config.preview) refresh().then(count).catch(() => {}); });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();



